import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { BaseService } from "../base.service";
import { NotificationService } from "../util/notification.service";
import { ModuleEnum } from "./enums/module.enum";
import { ModuleConfigurationProperty } from "./models/module-configuration-property.model";
import { ModuleConfiguration } from "./models/module-configuration.model";

@Injectable({
  providedIn: 'root'
})
export class ModuleConfigurationService extends BaseService {
  // MAM
  mobilityAccountManagerProperties$ = new BehaviorSubject<ModuleConfigurationProperty[]>(null);

  constructor(private httpClient: HttpClient, protected notificationService: NotificationService, protected translate: TranslateService,) {
    super(notificationService, translate);
  }

  getModuleConfiguration(module: string): Observable<ModuleConfiguration> {
    return this.httpClient.get<ModuleConfiguration>(`${environment.api.mobilityUrl}/v1/modules/${module}/config`);
  }

  getMobilityAccountManagerConfiguration() {
    return this.getModuleConfiguration(ModuleEnum.MOBILITY_ACCOUNT_MANAGER).pipe(
      map((moduleConfiguration: ModuleConfiguration) => {
        if (moduleConfiguration.properties) {
          return moduleConfiguration.properties;
        }
        return null;
      }),
      tap((properties: ModuleConfigurationProperty[]) => {
        this.mobilityAccountManagerProperties$.next(properties);
      }),
      catchError(_err => {
        if (_err.status === 403) {
          console.error(`The agent doesn't have the permission to get this configuration`);
        }
        console.error(_err);
        return throwError(() => _err);
      })
    )
  }

}
